import { io } from 'socket.io-client';

const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:3000';

export const socket = io(WS_URL, { autoConnect: true });

export default socket;
